<template>
  <div id="products" class="px-4 py-4">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'subcategory-create' })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </div>
    <subcategory-list />
  </div>
</template>
<script>
import SubcategoryList from "@/components/subcategory_management/SubcategoryList";

export default {
  components: {
    SubcategoryList
  },
  data: () => ({}),
  computed: {}
};
</script>

<style></style>
